import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlRemovedor'
})
export class HtmlRemovedorPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = value.replace(/<\/?[^>]+(>|$)/g, "");
    // value = value+''.replace(/_/g, '</br>');
    return value;
  }

}
